module.exports = __webpack_public_path__ + "img/zfb_icon.c7135b4.png";